<!--
  @Description: 申请机构版静态页
  @Author: wang.y 
  @Date: 2022-03-23 
-->
<template>
  <div class="apply-try">
    <div class="banner"></div>
    <div class="container">
      <div class="left">
        <img :src="static_img_url + 'pic/logo_whrite.png'" class="main-logo" />
        <div class="main-title">动脉橙产业智库2.0</div>
        <div class="main-decs">行业知识管理工具，工作效率10倍提升，辅助决策。</div>
        <div class="main-number">
          <div class="main-number-item" v-for="item,index in number_list" :key="index">
            <div class="num">
              <span>{{item.num}}</span>
              <span class="spa1">+</span>
            </div>
            <div class="font">{{item.font}}</div>
          </div>
        </div>
        <template v-if="is_affix">
          <Affix :offset-top="64" class="container-affix" @on-change="handleChangeAffix">
            <div class="nav">
              <div v-for="item,index in module_list" :key="item.id" :class="{'on': active == index, 'new-ability': item.name == '特色功能'}" @click="handleClickNav(index)">
                <span v-if="index != 0">{{item.name}}</span>
                <img :src="active == 0 ? static_img_url + 'pic/apply/orange_new.png' : static_img_url + 'pic/apply/black_new.png'" v-if="index == 0">
              </div>
            </div>
          </Affix>
          <div class="nav-bg" v-if="affix_status"></div>
        </template>
        <div class="main-container">
          <div class="module" v-for="item,index in module_content" :key="index" :ref="'module' + index">
            <div class="module-header">
              <div class="title" v-if="index > 0">{{item.title}}</div>
              <div class="title" v-else>
                <img class="img-title" :src="static_img_url + 'pic/apply/new_use.png'" />
                <!-- <img class="img-tag" :src="static_img_url + 'pic/apply/new.png'" /> -->
              </div>
              <div class="icons">
                <div class="icon-item" v-for="item2,index2 in item.icons" :key="index2">
                  <img :src="static_img_url + item2.icon" />
                  <div v-html="item2.name"></div>
                </div>
              </div>
            </div>
            <div class="module-desc">{{item.decs}}</div>
            <div class="module-img" v-for="imgItem, indexImg in item.main_path" :key="indexImg">
              <img :src="static_img_url + imgItem" />
            </div>
          </div>
        </div>
        <div ref="bottom-container" class="bottom-container">
          <div class="module">
            <div class="module-header">
              <div class="title">合作案例</div>
            </div>
            <div class="logo-list">
              <div class="logo" v-for="item,index in Array(32)" :key="index">
                <img :src="static_img_url + 'pic/apply/m' + (index+1) + '.png'" />
              </div>
            </div>
          </div>
          <div class="module contact-module">
            <div class="module-header">
              <div class="title">联系我们</div>
            </div>
            <!-- <div class="contact-list">
              <div class="contact-li" v-for="item,index in contact_list" :key="index">
                <div class="font">
                  <div class="title">{{item.title}}</div>
                  <div class="name">{{item.name}}</div>
                  <div class="tel">{{item.tel}}</div>
                </div>
                <img :src="static_img_url + item.ewm" />
              </div>
            </div> -->
            <div class="contact-container">
              <div class="font">
                <div class="p1">问题反馈或商务需求，请扫描二维码联系我们</div>
                <p class="tip"><span>微信</span>扫码添加动脉网小助手</p>
                <div class="line"></div>
              </div>
              <img :src="static_img_url + 'pic/applyTry2.png'" />
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- <div class="form-container" ref="form-container" :style="'transform: translateY(' + translate_y2 + 'px);'">
          <div class="form-top">动脉橙机构版试用申请</div>
          <div class="form-decs">动脉橙机构版为企业、金融机构和政府提供更专业、全面的功能及服务。</div>
          <template v-if="!submit_status">
            <div class="form-body">
              <Form ref="apply-form" :model="params" label-position="left" :rules="form_rules" :label-width="90">
                <FormItem label="关注的领域" prop="sel_ly">
                  <Select v-model="params.sel_ly" multiple :max-tag-count="1">
                    <Option :value="item" v-for="item,index in tag_list" :key="index">{{item}}</Option>
                  </Select>
                </FormItem>
                <FormItem label="联系人" prop="name">
                  <Input v-model="params.name" placeholder="请输入联系人" />
                </FormItem>
                <div class="nc-cnt" v-if="nc_status">
                  <div id="nc"></div>
                </div>
                <FormItem label="手机号" prop="mobile" v-show="!nc_status">
                  <Input v-model="params.mobile" placeholder="请输入联系电话" />
                </FormItem>
                <FormItem label="验证码" prop="code" class="code">
                  <Input v-model="params.code" placeholder="请输入验证码"></Input>
                  <Button type="text" v-if="code_status == 0" @click="getCode">获取验证码</Button>
                  <Button type="text" v-if="code_status == 1" class="gray">验证中</Button>
                  <Button type="text" v-if="code_status == 2" class="gray">{{wait}}s后重新获取</Button>
                  <Button type="text" v-if="code_status == 3" @click="getCode">重新获取</Button>
                </FormItem>
                <FormItem label="公司或机构" prop="comp_name">
                  <Input v-model="params.comp_name" placeholder="请输入公司或机构" />
                </FormItem>
                <FormItem label="职位" prop="title">
                  <Input v-model="params.title" placeholder="请输入职位" />
                </FormItem>
                <FormItem label="需求">
                  <Input v-model="params.summary" placeholder="请输入需求描述" />
                </FormItem>
              </Form>
              <div class="form-submit" @click="submitForm">提交申请</div>
            </div>
            <div class="form-bottom">提交信息后，我们会在1~2个工作日审核，<span>虚假信息不予通过</span>，审核通过后，会与您取得联系，请保持电话通畅。</div>
          </template>
          <div class="smt-cnt" v-else>
            <img class="smt-icon" :src="static_img_url + 'pic/buyvip/yes.png'" />
            <div class="smt-font">
              <p class="p1">提交成功，审核中</p>
              <p class="p2">在此期间如有任何疑问<br>可以扫描二维码添加在线客服咨询</p>
            </div>
            <img class="smt-ewm" :src="static_img_url + 'pic/apply/ewm3.png'" />
          </div>
        </div> -->
        <div class="form-container" ref="form-container" :style="'transform: translateY(' + translate_y2 + 'px);'">
          <div class="ewm-container">
            <div class="title">
              扫码添加小助手<br>申请动脉橙机构版试用
            </div>
            <img :src="static_img_url + 'pic/applyTry1.png'" />
            <p class="tip"><span>微信</span>扫码添加动脉网小助手</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { checkUserBehavior, addtryapplynew, addTryEnterPV } from '@/service'
export default {
  components: {},
  created() {
    if (this.$route.query.info_src) this.addTryEnterPV(this.$route.query.info_src)
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollChange()
      window.onscroll = this.debounce(this.scrollChange, 10)
    })
  },
  beforeDestroy() {
    clearInterval(this.waitInterval)
    this.waitInterval = ''
  },
  data() {
    return {
      // number_list: [
      //   { num: '15000', font: '行业宏观数据报告' },
      //   { num: '25000', font: '招投标数据' },
      //   { num: '31000', font: '医疗健康相关投资事件' },
      //   { num: '58000', font: '医疗健康相关公司' },
      // ],
      number_list: [
        { num: '500', font: '医疗健康细分赛道覆盖' },
        { num: '38000', font: '医疗健康领域招投标数据' },
        { num: '39000', font: '医疗健康领域投融资数据' },
        { num: '64800', font: '医疗健康相关公司' },
      ],
      module_list: [
        { name: '特色功能', id: 'module1' },
        { name: '产业知识库', id: 'module2' },
        { name: '动态资讯库', id: 'module3' },
        { name: '行业趋势库', id: 'module4' },
        { name: '行业数据库', id: 'module5' },
      ],
      module_content: [
        {
          title: '特色功能',
          decs: '',
          icons: [
            { name: '项目遴选', icon: 'pic/apply/track-4.png' },
            { name: '赛道遴选', icon: 'pic/apply/track-1.png' },
            { name: '图解报告', icon: 'pic/apply/track-2.png' },
            { name: '投融资看板', icon: 'pic/apply/track-3.png' },
          ],
          main_path: [
            'pic/apply/track-main-4.png',
            'pic/apply/track-main-1.png',
            'pic/apply/track-main-2.png',
            'pic/apply/track-main-3.png',
          ],
        },
        {
          title: '产业知识库',
          decs: '一图看懂行业划分，一次性了解赛道要点、公司分布、资本趋势、产品进展、政策发布……',
          icons: [
            { name: '持续更新+', icon: 'pic/apply/icon1-1.png' },
            { name: '提高产业认知', icon: 'pic/apply/icon1-2.png' },
            { name: '构建产业图谱', icon: 'pic/apply/icon1-3.png' },
          ],
          main_path: ['pic/apply/main1.png'],
        },
        {
          title: '动态资讯库',
          decs: '追踪医疗健康产业领域十万余家企业和机构最新动态。',
          icons: [
            { name: '及时覆盖', icon: 'pic/apply/icon2-1.png' },
            { name: '追求准确高效', icon: 'pic/apply/icon2-2.png' },
            { name: '提供产业情报', icon: 'pic/apply/icon2-3.png' },
          ],
          main_path: ['pic/apply/main2.png'],
        },
        {
          title: '行业趋势库',
          decs: '以可视化、可交互方式，从宏观面展示医药行业投融资趋势，反映市场热度领域的变迁图景。',
          icons: [
            { name: '宏观视角', icon: 'pic/apply/icon3-1.png' },
            { name: '跟踪融资趋势', icon: 'pic/apply/icon3-2.png' },
            { name: '关注热点<br>领域变迁', icon: 'pic/apply/icon3-3.png' },
          ],
          main_path: ['pic/apply/main3.png'],
        },
        {
          title: '行业数据库',
          decs: '涵盖医疗健康领域三大分类，市场规模、营业收入、企业融资、并购等细分数据维度，以及超十万家企业信息，包括公司基本情况、融资记录、高管团队和里程碑事件。',
          icons: [
            { name: '准确及时', icon: 'pic/apply/icon4-1.png' },
            { name: '挖掘数据价值', icon: 'pic/apply/icon4-2.png' },
            { name: '赋能产业认知', icon: 'pic/apply/icon4-3.png' },
          ],
          main_path: ['pic/apply/main4.png'],
        },
      ],
      contact_list: [
        {
          title: '体验反馈',
          name: '孙老师',
          tel: '18523202324（微信同号）',
          ewm: 'pic/apply/ewm1.png',
        },
        // {
        //   title: '内容服务',
        //   name: '唐老师',
        //   tel: '13102347860（微信同号）',
        //   ewm: 'pic/apply/ewm2.png',
        // },
        // {
        //   title: '数据服务',
        //   name: '唐老师',
        //   tel: '13102347860（微信同号）',
        //   ewm: 'pic/apply/ewm2.png',
        // },
        {
          title: '商务需求',
          name: '动脉橙客服',
          tel: '17338335471（微信同号）',
          ewm: 'pic/apply/ewm3.png',
        },
      ],
      tag_list: [
        '生物医药',
        '器械-应用科室',
        '器械-热门类别',
        '智慧医疗',
        '互联网+医疗健康',
        '数字疗法',
        '器械应用科室-IVD',
      ],

      params: {
        name: '',
        comp_name: '',
        title: '',
        summary: '',
        mobile: '',
        sel_ly: [],
        code: '',
      },
      form_rules: {
        name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            },
          },
        ],
        comp_name: [{ required: true, message: '请输入公司或机构', trigger: 'blur' }],
        title: [{ required: true, message: '请输入职位', trigger: 'blur' }],
        summary: [{ required: true, message: '请输入需求描述', trigger: 'blur' }],
        sel_ly: [
          { required: true, type: 'array', min: 1, message: '请选择申请领域', trigger: 'change' },
        ],
      },
      active: 0,
      translate_y2: 0,
      code_status: 0, //0默认可点击 1点击 2等待 3重新获取
      nc_status: false,
      submit_status: false,
      waitInterval: '',
      wait: 60,
      is_affix: true,
      affix_status: false,
    }
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
  },
  methods: {
    /**
     * @description: 滚动条防抖
     * @param {*} fn
     * @param {*} wait
     * @return {*}
     */
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    handleClickNav(index) {
      // if (this.active != index) {
      let toT = this.$refs['module' + index][0].offsetTop - 30
      if (document.documentElement) document.documentElement.scrollTop = toT
      else document.body.scrollTop = toT
      // }
    },
    scrollChange() {
      let footer_height = document.getElementById('home-footer').offsetHeight
      let scroll_top = document.documentElement.scrollTop || document.body.scrollTop //滚动条的值
      let viewH = window.innerHeight - 64
      let bottomH = this.$refs['bottom-container'].offsetTop - viewH / 2
      let y = bottomH - scroll_top
      this.is_affix = y > 0

      let formH = this.$refs['form-container'].clientHeight
      let formB = (viewH - formH) / 2
      let y2 =
        scroll_top + window.innerHeight - (document.body.clientHeight - footer_height) - formB + 48
      this.translate_y2 = y2 > 0 ? 0 - (formH / 2 + y2) : 0 - formH / 2

      let topArr = []
      this.module_list.forEach((item, index) => {
        let top = this.$refs['module' + index][0].offsetTop - 30
        topArr.push(top)
      })
      for (let i = 0; i < topArr.length; i++) {
        if (scroll_top >= topArr[i]) {
          this.active = i
        }
      }
    },
    getCode() {
      this.nc_status = false
      const _this = this
      this.$refs['apply-form'].validateField('mobile', (valid) => {
        if (!valid) {
          this.code_status = 1
          window.nvc.getNVCValAsync(function (nvcVal) {
            _this.checkUserBehavior(nvcVal)
          })
        }
      })
    },
    async checkUserBehavior(nvcVal) {
      let res = await checkUserBehavior(
        {
          data: nvcVal,
          mobile: this.params.mobile,
          scene: 'vbdata_try_enter',
        },
        (error) => this.$Message.error('请求错误！')
      )
      if (res.status == 'success') {
        if (res.code == 100 || res.code == 200) {
          this.code_status = 2
          this.waitInterval = setInterval(() => {
            this.wait--
            if (this.wait == 0) {
              this.code_status = 3
              this.wait = 60
              clearInterval(this.waitInterval)
            }
          }, 1000)
          this.nc_status = false
          this.$Message.success('验证码发送成功')
        } else if (res.code == 400) {
          this.nc_status = true
          var ncoption = {
            renderTo: 'nc',
          }
          this.$nextTick(() => {
            window.nvc.getNC(ncoption)
          })
        } else {
          this.code_status = 3
          this.$Message.error('验证被拦截，请稍后再试或联系客服')
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    submitForm() {
      // this.submit_status = true
      this.$refs['apply-form'].validate(async (valid) => {
        if (valid) {
          let txt = this.params.sel_ly.join('，')
          let form_params = {
            user_key: this.$store.state.user_key || '',
            name: this.params.name,
            comp_name: this.params.comp_name,
            title: this.params.title,
            summary:
              '申请体验版块：“动态资讯库、产业知识库、行业数据库”；申请体验领域：“' +
              txt +
              '”。' +
              this.params.summary,
            info_src: this.$route.query.info_src || '',
            mobile: this.params.mobile,
            code: this.params.code,
            scene: 'vbdata_try_enter',
          }
          let res = await addtryapplynew(form_params, (error) => {
            this.$Message.error('请求失败！')
          })
          if (res.status == 'success') {
            this.submit_status = true
            this.$Message.success('提交成功！')
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
    async addTryEnterPV(info_src) {
      let res = await addTryEnterPV(
        {
          info_src: info_src,
          userid: this.$store.state.user.id,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
    },
    handleChangeAffix(status) {
      this.affix_status = status
    },
  },
}
</script>
<style lang='stylus' scoped>
.fade-enter-active, .fade-leave-active
  transition all 0.3s
.fade-enter-to, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  opacity 0
  transform scale(0.9)
.apply-try
  position relative
  background-color #fff
.banner
  position absolute
  height 336px
  width 100%
  left 0
  top 0
  background url('~pic/index/banner.png') no-repeat center center
  background-color #05060c
  z-index 0
.container
  width 1200px
  margin 0 auto
  display flex
  line-height 1
  .left
    z-index 1
    padding-top 50px
    width 810px
    .main-logo
      width 126px
      height 41px
    .main-title
      font-size 68px
      font-weight bold
      color #FFFFFF
      margin-top 30px
      position relative
      &::after
        background-image url('../../../public/pic/apply/new_small.png')
        background-size 100%
        position absolute
        height 37px
        width 67px
        content ''
        top -19px
        // right 96px
    .main-decs
      font-size 28px
      font-weight bold
      color #FFFFFF
      margin-top 36px
    .main-number
      margin-top 40px
      margin-bottom 20px
      display flex
      justify-content space-between
      &-item
        width 194px
        height 92px
        background #FFFFFF
        box-shadow 0px 4px 40px 0px rgba(0, 0, 0, 0.1)
        border-radius 6px
        padding 0 16px
        display flex
        flex-direction column
        justify-content center
        .num
          font-size 40px
          color #FA7F50
          background linear-gradient(0deg, #FA7F50 0%, #F5C093 100%)
          -webkit-background-clip text
          -webkit-text-fill-color transparent
          .spa1
            font-size 20px
        .font
          font-weight 500
          color #333333
          margin-top 12px
    .nav
      height 50px
      display flex
      align-items center
      > div
        cursor pointer
        & + div
          margin-left 46px
        &:hover, &.on
          color #ff8824
        img
          width 55px
    .nav-bg
      height 50px
      position fixed
      background-color #fff
      top 64px
      width 100%
      left 0
      right 0
      z-index 9
      box-shadow 0 0 4px 0 rgba(0, 0, 0, 0.1)
    .module
      .module-header
        display flex
        justify-content space-between
        align-items center
        .title
          font-size 40px
          padding-bottom 34px
          position relative
          &:before
            content ''
            position absolute
            width 68px
            height 4px
            background #FA7F50
            left 0
            bottom 0
          .img-title
            width 156px
          .img-tag
            width 36px
            position absolute
            top -12px
            right -44px
        .icons
          display flex
          .icon-item
            width 90px
            height 90px
            background #FFFFFF
            box-shadow 0px 4px 40px 0px rgba(0, 0, 0, 0.1)
            border-radius 6px
            display flex
            flex-direction column
            justify-content center
            align-items center
            & + div
              margin-left 10px
            img
              height 26px
            div
              margin 7px 0 -2px
              font-size 13px
              line-height 18px
              text-align center
      .module-desc
        margin-top 18px
        line-height 20px
      .module-img
        margin-top 7px
        width 810px
        img
          width 873px
          margin-left -16px
      .logo-list
        padding-top 12px
        font-size 0
        display flex
        flex-wrap wrap
        .logo
          width 180px
          height 100px
          background #FFFFFF
          border 1px solid #EEEEEE
          display flex
          align-items center
          justify-content center
          margin 24px 24px 0 0
          &:nth-of-type(4n)
            margin-right 0
          img
            max-height 100%
            max-width 100%
      .contact-container
        background #F9F9F9
        display flex
        align-items center
        justify-content space-between
        padding 20px
        margin 24px 0 48px
        .font
          .p1
            font-size 18px
            color #3D3D3D
            line-height 25px
          .tip
            font-size 14px
            color #666666
            line-height 20px
            margin-top 10px
            span
              color #07C160
          .line
            width 100px
            height 1px
            background #FA7F50
            margin-top 17px
        img
          width 130px
          height 130px
      .contact-list
        padding 24px 0 48px
        display flex
        flex-wrap wrap
        .contact-li
          width 390px
          height 160px
          background #F9F9F9
          display flex
          align-items center
          justify-content space-between
          margin 12px 12px 0 0
          padding 20px 20px 20px 30px
          &:nth-of-type(2n)
            margin-right 0
          .font
            .title
              font-size 18px
              padding-bottom 15px
              position relative
              &:before
                content ''
                position absolute
                width 36px
                height 1px
                background #FA7F50
                left 0
                bottom 0
            .name, .tel
              margin-top 20px
          img
            max-height 100%
            max-width 100%
    .main-container
      .module
        padding 40px 47px 0 16px
        width 873px
        margin-left -16px
        overflow hidden
    .bottom-container
      .module
        margin-top 50px
  .right
    flex 0 0 360px
    margin-left 30px
    z-index 1
    .form-container
      position fixed
      top calc(50% + 32px)
      transform translateY(-50%)
      width 360px
      padding 20px 30px 30px
      background #FFFFFF
      box-shadow 0px 4px 40px 0px rgba(0, 0, 0, 0.1)
      z-index 12
      .ewm-container
        width 100%
        .title
          font-size 18px
          color #3D3D3D
          line-height 25px
          border-left 3px solid #FF8824
          padding-left 10px
        img
          width 208px
          height 208px
          margin 20px auto 0
          display block
        .tip
          font-size 14px
          color #666666
          line-height 20px
          margin-top 12px
          text-align center
          span
            color #07C160
      .form-top
        font-size 18px
        display flex
        align-items center
        &:before
          content ''
          width 3px
          height 16px
          background #FA7F50
          margin-right 10px
      .form-decs
        color #666666
        line-height 20px
        margin-top 12px
        padding-bottom 16px
        border-bottom 1px solid #EEEEEE
      .form-bottom
        color #666666
        line-height 18px
        span
          color #ff8824
      .form-body
        padding 16px 0
        .nc-cnt
          width 300px
          height 34px
          margin -2px 0 18px
          >>> .nc_scale
            span
              box-sizing content-box
              &.nc-lang-cnt
                display inline !important
        >>> .ivu-form-item
          margin-bottom 20px
          .ivu-form-item-label
            padding 8px 0
            position relative
            padding-left 10px
            line-height 1
            &:before
              position absolute
              left 0
          .ivu-form-item-error-tip
            padding-top 2px
            font-size 12px
          .ivu-form-item-content
            line-height 1
            min-height 30px
            position relative
          .ivu-input, .ivu-select-selection
            height 30px
          &.code
            .ivu-form-item-content
              position relative
              .ivu-input
                padding-right 100px
              .ivu-btn-text
                position absolute
                top 1px
                right 1px
                height 28px
                font-size 12px
                line-height 1
                padding 0 10px
                border 0
                color #FA7F50
                box-shadow none
                outline none
                &:hover
                  color #ff8824
                &.gray
                  color #bbb
        .form-submit
          width 96px
          height 32px
          background #FA7F50
          border-radius 4px
          color #FFFFFF
          display flex
          justify-content center
          align-items center
          margin 0 auto
          cursor pointer
          &:hover
            background #ff8824
      .smt-cnt
        display flex
        flex-direction column
        align-items center
        justify-content center
        height 468px
        .smt-icon
          width 122px
        .smt-font
          text-align center
          margin-top 26px
          .p1
            font-size 16px
          .p2
            margin-top 10px
            font-size 13px
            color #999999
            line-height 20px
        .smt-ewm
          margin-top 30px
          width 100px
@media screen and (max-height 800px)
  .container
    width 1100px
    .left
      width 740px
      .nav, .nav-bg
        height 36px
      .module
        .module-header
          .title
            font-size 34px
            padding-bottom 24px
          .icons
            .icon-item
              width 80px
              height 80px
              box-shadow 0px 4px 20px 0px rgba(0, 0, 0, 0.1)
              div
                margin 4px 0 -2px
                font-size 12px
                line-height 16px
        .logo-list
          .logo
            width 160px
            height 89px
            margin 16px 16px 0 0
        .module-img
          width 740px
          img
            width 795px
            margin-left -14px
        .contact-list
          .contact-li
            width 340px
            height 148px
      .main-number
        &-item
          width 172px
          height 86px
          .num
            font-size 32px
          .font
            margin-top 10px
            font-size 12px
      .main-container
        .module
          padding 30px 41px 0 14px
          width 795px
          margin-left -14px
      .bottom-container
        .module
          margin-top 40px
    .right
      flex 0 0 340px
      margin-left 20px
      .form-container
        padding 16px 20px
        width 340px
        .form-top
          font-size 16px
        .form-decs
          line-height 16px
          margin-top 10px
          padding-bottom 12px
          font-size 13px
        .form-body
          padding 10px 0
          .nc-cnt
            height 34px
            margin -2px 0 13px
          >>> .ivu-form-item
            margin-bottom 10px
        .smt-cnt
          height 380px
          .smt-icon
            width 100px
        .form-bottom
          line-height 16px
          font-size 13px
.new-ability
  position relative
  &::after
    background-image url('../../../public/pic/apply/new_mini.png')
    background-size 100%
    position absolute
    height 10px
    width 20px
    content ''
    top -8px
    right -20px
</style>